export default (store) => ({
  path : 'board',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Board = require('./components').default

      /*  Return getComponent   */
      cb(null, Board)

    /* Webpack named bundle   */
    }, 'board')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Board/index.js